<template>
    <div class="address-search">
        <input type="text" v-model="searchQuery" @input="onSearchInput" placeholder="Cari alamat..."
            class="form-control form-control-md" />
        <ul v-if="searchResults.length" class="suggestions-list">
            <li v-for="result in searchResults" :key="result.raw?.osm_id || result.label + result.y + result.x"
                @click="selectAddress(result)">
                {{ result.label }}
            </li>
        </ul>
    </div>
</template>

<script>
import { OpenStreetMapProvider } from 'leaflet-geosearch';

export default {
    name: 'TechnicianAddressSearch',
    props: {
        // Nilai awal dari luar (misal dari detail teknisi)
        value: { type: String, default: '' }
    },
    data() {
        return {
            searchQuery: this.value,
            searchResults: [],
            provider: new OpenStreetMapProvider({
                params: {
                    'accept-language': 'id',     // Prioritaskan hasil dalam bahasa Indonesia
                    countrycodes: 'id',          // Batasi pencarian hanya di Indonesia[reference:2]
                    limit: 20,                   // Tingkatkan batas hasil dari default (biasanya 10) jadi 20
                    addressdetails: 1,           // Dapatkan detail alamat yang lebih lengkap
                    namedetails: 1,
                    extratags: 1,
                }
            }),
            debounceTimer: null,
        };
    },
    watch: {
        searchQuery(newVal) {
            this.$emit('input', newVal);
        },
        value(newVal) {
            this.searchQuery = newVal;
        }
    },
    methods: {
        onSearchInput() {
            // Hapus timer lama jika ada
            if (this.debounceTimer) clearTimeout(this.debounceTimer);
            // Timer baru: hanya cari setelah 300ms selesai mengetik
            this.debounceTimer = setTimeout(async () => {
                if (this.searchQuery.length < 3) {
                    this.searchResults = [];
                    return;
                }
                try {
                    // Panggil API Nominatim
                    const results = await this.provider.search({ query: this.searchQuery });
                    this.searchResults = results;
                } catch (error) {
                    console.error("Gagal mencari alamat:", error);
                    this.searchResults = [];
                }
            }, 300);
        },
        selectAddress(result) {
            // 1. Isi input dengan alamat yang dipilih
            this.searchQuery = result.label;
            // 2. Bersihkan daftar saran
            this.searchResults = [];
            // 3. Kirim data ke komponen induk (TechnicianEditPanel)
            this.$emit('input', result.label);
            this.$emit('select', {
                address: result.label,
                lat: result.y,   // hasil dari provider menggunakan 'y' untuk latitude
                lng: result.x,   // dan 'x' untuk longitude
            });
        }
    }
};
</script>

<style scoped>
.address-search {
    position: relative;
}

.suggestions-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    list-style: none;
    padding: 0;
    margin: 0;
}

.suggestions-list li {
    padding: 8px 12px;
    cursor: pointer;
}

.suggestions-list li:hover {
    background-color: #f0f0f0;
}
</style>
